import { render } from "./AvatarRoundedCircle.vue?vue&type=template&id=dd1b1f8a"
import script from "./AvatarRoundedCircle.vue?vue&type=script&lang=js"
export * from "./AvatarRoundedCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__